import { Box, Typography } from '@mui/material';
import React from 'react';
import moment from 'moment';
import CustomTooltip from '../../utils/CustomTooltip';
import { globalClasses } from '../../utils/globalUtils';
import { classes } from './utils';
import { lightPalette } from '../../../../theme';

const OrganizationNameRow = (params) => {
  const organizationName = params?.data?.organization?.name || '-';

  if (params?.data !== undefined) {
    return (
      <CustomTooltip title={organizationName}>
        <Typography
          variant="body1"
          fontWeight="400"
          className={`${globalClasses.agGridCellCustomTypo} ${classes.documentRowTypographyColor}`}
        >
          {organizationName}
        </Typography>
      </CustomTooltip>
    );
  }
  return (
    <Typography variant="body1" fontWeight={400}>
      -
    </Typography>
  );
};
const StatusRenderer = (params) => {
  const status = params?.data?.status;
  if (params?.data !== undefined) {
    return (
      <CustomTooltip title={status}>
        <Typography
          variant="body1"
          fontWeight="400"
          className={`${globalClasses.agGridCellCustomTypo} ${classes.documentRowTypographyColor}`}
        >
          {status}
        </Typography>
      </CustomTooltip>
    );
  }
  return (
    <Typography variant="body1" fontWeight={400}>
      -
    </Typography>
  );
};
const TotalCreditsRenderer = (params) => {
  const totalCredits = params?.data?.total_amount;
  if (params?.data !== undefined && params?.data?.total_amount) {
    return (
      <CustomTooltip title={totalCredits}>
        <Typography
          variant="body1"
          fontWeight="400"
          className={`${globalClasses.agGridCellCustomTypo} ${classes.documentRowTypographyColor}`}
        >
          {totalCredits}
        </Typography>
      </CustomTooltip>
    );
  }
  return (
    <Typography variant="body1" fontWeight={400}>
      -
    </Typography>
  );
};

const timeStampDate = (params) => {
  const { value } = params;
  const formattedDate = moment.utc(value).local().format('DD-MM-YYYY HH:mm:ss');

  return (
    <Box>
      {value !== undefined && value !== null ? (
        <Typography variant="body1" fontWeight="400">
          {formattedDate}
        </Typography>
      ) : (
        <Typography>-</Typography>
      )}
    </Box>
  );
};

const AddedByRenderer = (params) => {
  const addedBy = `${params?.data?.createdByUser?.first_name || '-'}  ${params?.data?.createdByUser?.last_name || '-'}`;
  if (
    params?.data &&
    params?.data?.createdByUser?.first_name !== undefined &&
    addedBy
  ) {
    return (
      <CustomTooltip title={addedBy}>
        <Typography
          variant="body1"
          color={lightPalette.lunarBase.main}
          fontWeight="400"
          className={classes.documentRowTypography}
        >
          {addedBy || '-'}
        </Typography>
      </CustomTooltip>
    );
  }
  return <Typography>-</Typography>;
};
const CreditsAddedRenderer = (params) => {
  const creditsAdded = params?.data?.no_of_credits;
  if (params?.data && creditsAdded) {
    return (
      <CustomTooltip title={creditsAdded}>
        <Typography
          variant="body1"
          color={lightPalette.lunarBase.main}
          fontWeight="400"
          className={classes.documentRowTypography}
        >
          {creditsAdded}
        </Typography>
      </CustomTooltip>
    );
  }
  return <Typography>-</Typography>;
};
const MessageRenderer = (params) => {
  const message = params?.data?.message;
  if (params?.data && message) {
    return (
      <CustomTooltip title={message}>
        <Typography
          variant="body1"
          color={lightPalette.lunarBase.main}
          fontWeight="400"
          className={classes.documentRowTypography}
        >
          {message}
        </Typography>
      </CustomTooltip>
    );
  }
  return <Typography>-</Typography>;
};

const paymentColumnDef = (
  gridSettingData,
  gridKey,
  customFilterValue,
  screenWidth,
) => {
  const isSmallScreen = screenWidth < 600;

  return [
    // Checkbox Column
    {
      headerName: ' ',
      field: ' ',
      minWidth: isSmallScreen ? 50 : 70,
      maxWidth: isSmallScreen ? 50 : 70,
      headerComponent: 'HeaderCheckbox',
      checkboxSelection: true,
      sortable: false,
      resizable: false,
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
    },
    // Organization Name
    {
      headerName: 'Organization Name',
      field: 'organization_name',
      minWidth: isSmallScreen ? 150 : 200,
      maxWidth: isSmallScreen ? 180 : 220,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      cellRenderer: OrganizationNameRow,
      filter: true,
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      pinned: isSmallScreen ? '' : 'left',
      lockPinned: true,
      lockPosition: true,
      hide: false,
    },
    // Status
    {
      headerName: 'Status',
      field: 'status',
      minWidth: isSmallScreen ? 150 : 200,
      maxWidth: isSmallScreen ? 180 : 220,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      filter: 'true',
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: StatusRenderer,
    },
    // Credits Added
    {
      headerName: 'Credits Added',
      field: 'no_of_credits',
      minWidth: isSmallScreen ? 150 : 200,
      maxWidth: isSmallScreen ? 180 : 220,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      filter: true,
      suppressMenu: true,
      type: 'text',
      sortable: true,
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: CreditsAddedRenderer,
    },
    // Total Credits
    {
      headerName: 'Total Credits',
      field: 'total_amount',
      minWidth: isSmallScreen ? 150 : 200,
      maxWidth: isSmallScreen ? 180 : 220,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      filter: 'true',
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: TotalCreditsRenderer,
    },
    // Added By
    {
      headerName: 'Added By',
      field: 'fullName',
      minWidth: isSmallScreen ? 150 : 200,
      maxWidth: isSmallScreen ? 180 : 220,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      filter: 'true',
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: AddedByRenderer,
    },
    // Message
    {
      headerName: 'Message',
      field: 'message',
      minWidth: isSmallScreen ? 180 : 230,
      maxWidth: isSmallScreen ? 200 : 250,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      filter: 'true',
      suppressMenu: true,
      type: 'text',
      filterParams: {
        filterOptions: ['contains'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
      },
      cellRenderer: MessageRenderer,
    },
    // Timestamp
    {
      headerName: 'Timestamp',
      field: 'payment_date',
      minWidth: isSmallScreen ? 250 : 300,
      maxWidth: isSmallScreen ? 280 : 330,
      headerComponent: 'ResponsiveSortingHeader',
      headerComponentParams: {
        gridSettingData,
        gridKey,
      },
      sortable: true,
      cellRenderer: timeStampDate,
      filter: 'agDateColumnFilter',
      type: 'date',
      suppressMenu: true,
      filterParams: {
        filterOptions: ['inRange'],
        buttons: ['reset', 'apply'],
        suppressAndOrCondition: true,
        closeOnApply: true,
        comparator: (filterDate, cellValue) => {
          const cellDate = new Date(cellValue);
          if (cellDate < filterDate) return -1;
          if (cellDate > filterDate) return 1;
          return 0;
        },
      },
    },
    // Empty Spacer Column
    {
      headerName: ' ',
      field: ' ',
      resizable: false,
      minWidth: isSmallScreen ? 150 : 200,
    },
  ];
};

export default paymentColumnDef;
